import { useState } from "react";

export const useModifyFontsFunc = () => {
  //   let families = { Primary: "Nunito", Secondary: "Roboto" };
  //   let weights = { Regular: 400, Medium: 500, SemiBold: 600, Bold: 900 };

  let mySentence =
    "A font style generator generates cool fonts but a font scale generator generates cool typographic scale for designers and developers";

  // SENTENCE's INITIAL STATE
  const [sentenceEdit, setSentenceEdit] = useState(mySentence);

  // Live VALUE  INPUT FOR SENTENCE
  const handleSentenceChange = (e) => {
    let entValue = e.target.value;
    entValue.length === 0
      ? setSentenceEdit(mySentence)
      : setSentenceEdit(entValue);
  };

  // SettingsBlock INITIAL STATE
  const [fontEdit, setFontEdit] = useState([
    {
      id: 0,
      side: ["h1", "Display 1", "Title"],
      fonFam: "Nunito",
      fonSize: "60px",
      fonHeight: "72",
      fonSpacing: "0",
      fonWeight: "bold",
    },
    {
      id: 1,
      side: ["h2", "Display 2"],
      fonFam: "Nunito",
      fonSize: "58px",
      fonHeight: "64",
      fonSpacing: "0",
      fonWeight: "bold",
    },
    {
      id: 2,
      side: ["h3", "Display 3", "Subtitle"],
      fonFam: "Cursive",
      fonSize: "48px",
      fonHeight: "56",
      fonSpacing: "0",
      fonWeight: "medium",
    },
    {
      id: 3,
      side: ["h4", "Display 4"],
      fonFam: "Arial",
      fonSize: "38px",
      fonHeight: "48",
      fonSpacing: "0",
      fonWeight: "regular",
    },
    {
      id: 4,
      side: ["h5", "Display 5", "Form Label", "Pagination"],
      fonFam: "Nunito",
      fonSize: "18px",
      fonHeight: "28",
      fonSpacing: "0",
      fonWeight: "regular",
    },
    {
      id: 5,
      side: ["h6", "Display 6", "Nav Menu", "Default Link", "Button Text"],
      fonFam: "Roboto",
      fonSize: "16px",
      fonHeight: "24",
      fonSpacing: "0",
      fonWeight: "regular",
    },
  ]);

  // Live VALUE  INPUT
  const handleInputChange = (e, id) => {
    let entValue = e.target.value;

    // Got This value from input Property
    let inputName = e.target.name;

    fontEdit[id][inputName] = entValue;
    setFontEdit([...fontEdit]);
  };

  // Live Font OPTIONS INPUT
  const handleOptionChange = (e, id) => {
    let entValue = e.target.value;

    // Got This value from Select Property
    let optionName = e.target.name;
    // console.log(e.target, optionName);
    fontEdit[id][optionName] = entValue;
    setFontEdit([...fontEdit]);
  };

  return {
    fontEdit,
    setFontEdit,
    sentenceEdit,
    handleSentenceChange,
    handleInputChange,
    handleOptionChange,
  };
};
